import { useForm } from "@inertiajs/react"

import { Button } from "@/components/ui/button"
import { Panel } from "@/components/ui/panel"
import { TextArea } from "@/components/ui/textarea"
import { adminSchoolNotePath } from "@/routes"

/** The editorial angle, "what this school is": one editable note. */
export function NoteForm({
  schoolId,
  note,
}: {
  schoolId: number
  note: string | null
}) {
  const form = useForm<{ body: string; [key: string]: string }>({
    body: note ?? "",
  })

  const submit = (e: React.FormEvent) => {
    e.preventDefault()
    form.transform((data) => ({ note: { body: data.body } }))
    form.patch(adminSchoolNotePath(schoolId), { preserveScroll: true })
  }

  return (
    <Panel
      title="What this school is"
      description="Your words, for whoever calls next."
    >
      <form onSubmit={submit} className="flex flex-col gap-3">
        <TextArea
          aria-label="Note"
          rows={4}
          value={form.data.body}
          onChange={(value: string) => form.setData("body", value)}
        />
        <div className="flex items-center justify-end gap-2">
          {form.isDirty && (
            <Button size="sm" color="secondary" onPress={() => form.reset()}>
              Discard
            </Button>
          )}
          <Button
            size="sm"
            color="primary"
            type="submit"
            isDisabled={!form.isDirty}
            isLoading={form.processing}
          >
            Save note
          </Button>
        </div>
      </form>
    </Panel>
  )
}
